export { default as PumpLandingTemplate } from './PumpLanding';